import { memo, useCallback } from 'react';
import { HStack, VStack } from '@cbhq/cds-web/layout';
import { TextTitle3, TextLabel2 } from '@cbhq/cds-web/typography';
import { Button } from '@cbhq/cds-web/buttons/Button';
import { SpotSquare } from '@cbhq/cds-web/illustrations';
import { SummaryCard } from '@/components/common/SummaryCard';

const VERIFY_URL = 'https://coinbase.com/onchain-verify';

export const DividendsPayoutCard = memo(function DividendsPayoutCard() {
  const handleGetVerified = useCallback(() => {
    window.open(VERIFY_URL, '_blank', 'noopener,noreferrer');
  }, []);

  const header = (
    <HStack justifyContent="space-between" alignItems="flex-start">
      <TextTitle3 as="h2">Dividends Payout</TextTitle3>
      <SpotSquare name="retailUSDCRewards" scaleMultiplier={0.5} />
    </HStack>
  );

  return (
    <SummaryCard header={header} testID="dividends-payout-card">
      <VStack paddingX={3} gap={3}>
        <TextLabel2 as="p" color="fgMuted">
          Verification on Coinbase is required to receive dividends. Payouts are currently available
          for U.S. users only.
        </TextLabel2>
        <VStack alignItems="flex-start">
          <Button variant="primary" compact onClick={handleGetVerified}>
            Get verified
          </Button>
        </VStack>
      </VStack>
    </SummaryCard>
  );
});
